import { MASTER_CODE_REQUEST, LOGOUT } from "../actionTypes";

const openMasterCode = (payload) => {
  return {
    type: MASTER_CODE_REQUEST,
    payload,
  };
};

const logout = () => {
  return {
    type: LOGOUT,
  };
};

export const authActions = {
  openMasterCode,
  logout
};
